import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import SummaryTimeOff from '@/types/table/summaryTimeOff';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface SummaryTimeOffData extends SummaryTimeOff {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class SummaryTimeOffController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryTimeOffData>>(API_CONTEXT + '/app/summaryTimeOff/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<SummaryTimeOffData>(API_CONTEXT + '/app/summaryTimeOff/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/summaryTimeOff/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/summaryTimeOff/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/summaryTimeOff/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryTimeOff/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryTimeOff/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryTimeOff/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryTimeOff/deleteBatch', params, httpOptions);
  }
  static salaryExchange(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryTimeOff/salaryExchange', params, httpOptions);
  }

    static listDetail(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryTimeOffData>>(API_CONTEXT + '/app/summaryTimeOff/listDetail', params, httpOptions);
  }

  // 导出详情
  static exportDetail(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/summaryTimeOff/exportDetail', params, fileName);
  }
}
